export const ru = {
    changeable: 'Обмен есть',
    not_changeable: 'Без обмена',
    unknown_changeable: 'Нет информации об обмене',
    not_refundable: 'Без возврата',
    unknown_refundable: 'Нет информации о возврате',
    refundable: 'Возврат есть',
};
